<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item
          label="分类"
          prop="dictionary_cate_id"
          :rules="[{ required: true, message: '请选择分类', trigger: 'blur' }]"
        >
          <el-select
            v-model="state.model.dictionary_cate_id"
            :clearable="false"
            @change="onCateChange"
          >
            <el-option
              v-for="item in state.cateData"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadCate()">刷新</el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="所属上级">
          <el-tree-select
            v-model="state.model.pid"
            :data="state.treeData"
            node-key="id"
            clearable
            accordion
            :props="{ label: 'name' }"
            :render-after-expand="false"
            :highlight-current="true"
            :default-expand-all="true"
            :check-strictly="true"
            placeholder="--上级字典--"
            @clear="delete state.model.pid"
          >
            <template #default="{ data }">
              <div style="display: flex; align-items: center">
                {{ data.name }}
              </div>
            </template>
            <template #footer>
              <el-button size="small" @click="onLoadTree">刷新</el-button>
            </template>
          </el-tree-select>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请填写名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item label="序号">
          <el-input-number
            v-model="state.model.sort"
            :controls="false"
            :precision="0"
            class="number-input-left"
            :min="0"
            :max="999"
          ></el-input-number>
          <el-icon style="margin-left: 10px" color="#ffa500">
            <QuestionFilled />
          </el-icon>
          <text style="color: #ffa500; margin-left: 3px">
            默认0，仅支持0~999正整数；数值越小，越靠前
          </text>
        </el-form-item>
        <el-form-item label="说明">
          <el-input
            type="textarea"
            v-model="state.model.description"
          ></el-input>
        </el-form-item>
        <template v-if="props.id">
          <el-form-item label="创建时间">
            <el-input v-model="state.model.create_time" disabled></el-input>
          </el-form-item>
          <el-form-item label="修改时间">
            <el-input v-model="state.model.update_time" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  dictionary_add,
  dictionary_edit,
  dictionary_detail,
  dictionarycate_list,
  dictionary_list,
} from "@/http/api";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: { status: 1, sort: 0 },
    });
    onMounted(() => {
      onLoadCate();
      if (props.id) {
        dictionary_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            if (state.model.pid == 0) {
              delete state.model.pid;
            }

            dictionary_list({
              limit: 0,
              sort_field: "sort",
              dictionary_cate_id: state.model.dictionary_cate_id,
            }).then((res) => {
              if (res.status == 200) {
                state.treeData = res.data.data?.list;
              }
            });
          }
        });
      }
    });

    const onLoadCate = () => {
      dictionarycate_list().then((res) => {
        if (res.status == 200) state.cateData = res.data.data?.list;
      });
    };

    const onCateChange = (val) => {
      dictionary_list({
        limit: 0,
        sort_field: "sort",
        dictionary_cate_id: val,
      }).then((res) => {
        if (res.status == 200) {
          delete state.model.pid;
          state.treeData = res.data.data?.list;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            dictionary_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            dictionary_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadCate,
      onCateChange,
    };
  },
};
</script>
<style scoped lang="less"></style>
